const global = {
  loginName: ''
}
export default global



// WEBPACK FOOTER //
// ./src/utils/common.js